<template>
  <div class="tutorial-bottom">
    <h1>{{ content.title }}</h1>
    <div class="description-container">
      <p>{{ content.description }}</p>
      <tutorial-button
        :action="action"
        :content="content.cta"
      />
    </div>
    <img
      ref="arrowTutorial"
      class="arrow"
      :src="content.arrow"
      alt="arrow"
    >
  </div>
</template>

<script>
import mixin from './tutorialMixin'

export default {
  name: 'TutorialBottom',
  mixins: [mixin]
}
</script>

<style lang="scss">
.tutorial-bottom {
  z-index: 9004;
  position: fixed;
  top: 20%;
  left: 35%;

  .arrow {
    position: fixed;
    transform: translateY(10em) translateX(10em);
    top: 0px !important;
  }

  .description-container {
    width: 80%;
  }
}
</style>
